module.exports = "/_next/static/images/logo-4a533e8dc482e8dc915fef6d9ab21535.jpg";